import React, { Fragment } from "react";
import { TaskUpdateDrawer } from "./tasks/TaskUpdateDrawer";
import { TaskAssignModal } from "./tasks/TaskAssignModal";
import { TaskDeleteModal } from "./tasks/TaskDeleteModal";
import { TaskDoneModal } from "./tasks/TaskDoneModal";
import { KanbanCardUpdateDrawer } from "../routes/kanban/components/KanbanCardUpdateDrawer";
import { KanbanCardReadDrawer } from "../routes/kanban/components/KanbanCardReadDrawer";
import { TaskReadDrawer } from "../routes/tasks/components/TaskReadDrawer";
import { TaskCreateDrawer } from "./tasks/TaskCreateDrawer";
import { EntryAssignModal } from "../routes/entries/components/EntryAssignModal";
import { EntryAssignBulkModal } from "../routes/entries/components/EntryAssignBulkModal";
import { EntryDetailsDrawer } from "../routes/entries/components/EntryDetailsDrawer";
import { EntryUpdateDrawer } from "../routes/entries/components/EntryUpdateDrawer";
import { KanbanCardCreateDrawer } from "../routes/kanban/components/KanbanCardCreateDrawer";
import { EntryConvertModal } from "../routes/entries/components/EntryConvertModal";
import { EntryDeleteModal } from "../routes/entries/components/EntryDeleteModal";
import { EntryCreateModal } from "../routes/entries/components/EntryCreateModal";
import { TasksReadDrawer } from "../routes/entries/components/TasksReadDrawer";
import { KanbanCreateDrawer } from "../routes/kanban/components/KanbanCreateDrawer";
import { KanbanCardMovingReasonModal } from "../routes/kanban/components/KanbanCardMovingReasonModal";
import { KanbanCardMoveToOtherKanbanDrawer } from "../routes/kanban/components/KanbanCardMoveToOtherKanbanDrawer";
import { KanbanCardDeleteModal } from "../routes/kanban/components/KanbanCardDeleteModal";
import { KanbanActivityDrawer } from "../routes/kanban/components/KanbanActivityDrawer";
import { KanbanSettingsDrawer } from "../routes/kanban/components/KanbanSettingsDrawer";
import { KanbanAutomationDrawer } from "../routes/kanban/components/KanbanAutomationDrawer";
import { ModuleInstanceReadDrawer } from "../routes/modules/module-instance/ModuleInstanceReadDrawer";
import { SubscribeToUnlockModal } from "./SubscribeToUnlockModal";
import { ModuleDefinitionActivityDrawer } from "../routes/modules/module-definition/components/ModuleDefinitionActivityDrawer";
import { KanbanCardsExportDrawer } from "../routes/kanban/components/KanbanCardsExportDrawer";
import { SettingsTagsDrawer } from "../routes/settings/components/SettingsTagsDrawer";

export const GlobalDrawers: React.FC = () => {
  return (
    <Fragment>
      <TaskUpdateDrawer />
      <TaskAssignModal />
      <TaskDeleteModal />
      <TaskDoneModal />
      <TaskReadDrawer />
      <TaskCreateDrawer />
      <TasksReadDrawer />

      <EntryAssignModal />
      <EntryAssignBulkModal />
      <EntryDetailsDrawer />
      <EntryUpdateDrawer />
      <EntryDeleteModal />
      <EntryConvertModal />
      <EntryCreateModal />

      <SettingsTagsDrawer />

      <KanbanCardCreateDrawer />
      <KanbanCardReadDrawer />
      <KanbanCardUpdateDrawer />
      <KanbanCreateDrawer />
      <KanbanCardMovingReasonModal />
      <KanbanCardMoveToOtherKanbanDrawer />
      <KanbanCardDeleteModal />
      <KanbanSettingsDrawer />
      <KanbanAutomationDrawer />
      <KanbanActivityDrawer />
      <KanbanCardsExportDrawer />

      <ModuleInstanceReadDrawer />
      <ModuleDefinitionActivityDrawer />

      <SubscribeToUnlockModal />
    </Fragment>
  );
};
